import {
  getTaxPaymentPeriods,
  getLicenseAsync,
  getLookupLicenseNoStateASync,
  getLookupLicenseAsync,
  updateLicense,
  renewLicense,
  bulkRenewLicenses,
  calculateLicenseFee,
  calculateLicenseRenwalFee,
  calculateBulkLicenseRenewalFee,
  getPropertyContactsByApplicationNumber,
  getPermitActionability,
  getReportingHistoryByApplicationNumber,
  getLicensesRentalscape,
  getCallerIdentityRentalscape,
  getLicenseByApnRentalscape,
  getLicenseByApplicationNumberRentalscape,
  updateLicenseRentalscape,
  getLicensesByAPN,
} from './licenses';
import {
  createNewLicense,
  createNewTaxCertificate,
  getAllLicensesForUserAsync,
  getTaxableLicenses,
  getTaxablePeriods,
  getUserLicenses,
  getUserRenewableLicenses,
} from './license';
import { getTranslationsAsync, getExpressConfig } from './misc';
import {
  getStripePublicKey,
  payByCreditCard,
  payByACHDirectDebit,
  payByCheck,
  calculateMultiPropertyTotAsync,
  checkLicensePayment,
  checkTaxPayment,
  payNothingGeneric,
  payNothing,
  payGeneric,
  eunaCancelPayment,
} from './payment';
import { lookupAddress, lookupAPNAddress, lookupAddressAPN } from './place';
import {
  fetchDocumentUploadToken,
  uploadDocument,
  fetchDocumentUploadTokenRentalscape,
} from './upload';
import {
  getCognitoUserIdByEmailAddressAsync,
  getUserDetailsAuthTokenAsync,
  createAccountAsync,
  editPersonDetailsAsync,
  getUserByEmailAddressRentalscapeAsync,
} from './user';

const apiAccess = {
  getCognitoUserIdByEmailAddressAsync,
  getUserDetailsAuthTokenAsync,
  createAccountAsync,
  editPersonDetailsAsync,
  getTaxPaymentPeriods,
  calculateMultiPropertyTotAsync,
  lookupAddress,
  lookupAPNAddress,
  getUserLicenses,
  getLicenseAsync,
  getLicensesByAPN,
  getLookupLicenseAsync,
  getLookupLicenseNoStateASync,
  getAllLicensesForUserAsync,
  getUserRenewableLicenses,
  createNewLicense,
  createNewTaxCertificate,
  updateLicense,
  renewLicense,
  bulkRenewLicenses,
  calculateLicenseFee,
  calculateLicenseRenwalFee,
  calculateBulkLicenseRenewalFee,
  fetchDocumentUploadToken,
  fetchDocumentUploadTokenRentalscape,
  uploadDocument,
  getStripePublicKey,
  payByCreditCard,
  payByACHDirectDebit,
  payByCheck,
  payGeneric,
  checkTaxPayment,
  checkLicensePayment,
  payNothing,
  payNothingGeneric,
  getPropertyContactsByApplicationNumber,
  getPermitActionability,
  getReportingHistoryByApplicationNumber,
  eunaCancelPayment,
  getTranslationsAsync,
  getExpressConfig,
  getLicensesRentalscape,
  getCallerIdentityRentalscape,
  getLicenseByApnRentalscape,
  getLicenseByApplicationNumberRentalscape,
  updateLicenseRentalscape,
  getUserByEmailAddressRentalscapeAsync,
  getTaxableLicenses,
  getTaxablePeriods,
};

export { lookupAddress, lookupAPNAddress, lookupAddressAPN };

export default apiAccess;
